let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("d1W0Z")).then(() => parcelRequire('4CMZN'));